import { BlockStack, Card, Tooltip, InlineGrid, InlineStack, Text, Badge, ResourceList, ResourceItem, Icon, EmptyState, Image, Tag } from '@shopify/polaris';
import {
  ClockIcon, ImagesIcon, ShippingLabelIcon, CursorFilledIcon, CashDollarIcon, CaretDownIcon
} from '@shopify/polaris-icons';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { usePartnerUp } from '../../providers/PartnerUpStoreProvider';
import {
  numberToUSD,
  dealNeedsAffiliateCode,
  dealApplicationNeedsReview,
  dealNeedsContentReview,
  getRequiresPayment,
  dealHasOverdueContent,
  getRequiresAffiliatePayment
} from '../../utils';
// import CampaignModal from '../CampaignModal';

function getCampaignStats(campaigns, deals, allCodes, pastPayments) {

  const campaignsMap = campaigns?.reduce((a, campaign) => {
    const campaignCreators = deals
      ?.filter(deal => {

        return deal.campaignID === campaign.id
      })?.reduce((a, deal) => {
        a[deal.creatorID] = true;
        return a;
      }, {})

    a[campaign.id] = {
      ...campaign,
      clicks: 0,

      totalClicks: 0,
      totalRevenue: 0,
      productCost: 0,
      shippingCost: 0,
      commission: 0,
      fixedPayments: 0,

      creators: Object.keys(campaignCreators || {})?.length
    }
    return a;
  }, {}) || {}


  allCodes?.forEach((code) => {
    if (campaignsMap[code.campaignID]) {
      campaignsMap[code.campaignID].totalClicks += code.uniqueClicks || 0
      const orders = code.orders;
      if (orders?.length) {
        orders.forEach(order => {
          const commissionPayment = code.commission ? ((Number(code.commission) / 100) * Number(order.subtotalPriceSet?.shopMoney?.amount)) : 0

          campaignsMap[code.campaignID].totalRevenue += Number(order.subtotalPriceSet?.shopMoney?.amount) || 0
          campaignsMap[code.campaignID].commission += commissionPayment || 0

        })
      }
    }
  }, {})

  deals?.forEach(deal => {
    if (campaignsMap[deal.campaignID]) {
      if (deal?.order?.id) {
        campaignsMap[deal.campaignID].productCost += deal.order.totalCost || 0
        campaignsMap[deal.campaignID].shippingCost += deal.order.shippingCost || 0
      }
      if (deal?.additionalOrders?.length) {
        deal.additionalOrders.forEach(order => {
          if (!order?.id) return
          campaignsMap[deal.campaignID].productCost += order.totalCost || 0
          campaignsMap[deal.campaignID].shippingCost += order.shippingCost || 0
        })
      }
    }
  })

  pastPayments?.forEach(payment => {
    if (campaignsMap[payment.campaignID] && payment.paymentType === 'fixed' && payment.processed) {
      campaignsMap[payment.campaignID].fixedPayments += payment.amount || 0
    }
  })

  return Object.values(campaignsMap || {});
}

export function getTaskIcon(task, taskString) {
  switch (task) {
    case 'Need Order':
      return (
        <Badge status="info">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={ShippingLabelIcon} color="highlight" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    case 'Need Affiliate Code':
      return (
        <Badge status="info">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={CursorFilledIcon} color="highlight" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    case 'New Applicant':
      return (
        <Badge status="success">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={CursorFilledIcon} color="success" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    case 'Content Review':
      return (
        <Badge status="info">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={ImagesIcon} color="interactive" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    case 'Overdue Content':
      return (
        <Badge status="">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={ClockIcon} color="subdued" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    case 'Need Payment':
      return (
        <Badge status="success">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={CashDollarIcon} color="success" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
    default:
      return (
        <Badge status="warning">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={CursorFilledIcon} color="warning" />
            </InlineStack>
            <Text>{taskString}</Text>
          </InlineStack>
        </Badge>
      )
  }
}

export default function CampaignsTable({ minWidth = true, onCampaignClick, onCreateCampaign, showTasks = true }) {
  const { campaigns, deals, initialCampaign, setInitialCampaign, content, store, allCodes, leads, pastPayments } = usePartnerUp();
  const [campaignOpen, setCampaignOpen] = useState(initialCampaign || null);

  const resourceName = {
    singular: 'campaign',
    plural: 'campaigns',
  };

  console.log('initialCampaign', initialCampaign)
  useEffect(() => {
    if (initialCampaign) {
      setCampaignOpen(initialCampaign)
    }
  }, [initialCampaign])

  const campaignStats = useMemo(() => {
    return getCampaignStats(campaigns, deals, allCodes, pastPayments, leads)
  }, [campaigns, deals])

  console.log('campaignStats', campaignStats)

  const renderItem = useCallback(function(campaign) {
    const campaignDeals = deals?.filter(deal => deal.campaignID === campaign.id && deal.status !== 'archived') || []
    console.log('campaignDeals', campaignDeals)

    const campaignTasks = campaignDeals.reduce((a, deal) => {

      const reviewContent = content?.find(c => c.dealID === deal.id && c.status === 'needsReview')

      if (dealNeedsAffiliateCode(deal, allCodes)) {
        if (!a['Need Affiliate Code']) a['Need Affiliate Code'] = 0;
        a['Need Affiliate Code']++;
      }
      if (dealApplicationNeedsReview(deal)) {
        if (!a['New Applicant']) a['New Applicant'] = 0;
        a['New Applicant']++;
      }
      if (dealNeedsContentReview(deal, reviewContent)) {
        if (!a['Content Review']) a['Content Review'] = 0;
        a['Content Review']++;
      }
      if (dealHasOverdueContent(deal)) {
        if (!a['Overdue Content']) a['Overdue Content'] = 0;
        a['Overdue Content']++;
      }
      if (getRequiresPayment(deal, content) || getRequiresAffiliatePayment(deal, allCodes)) {
        if (!a['Need Payment']) a['Need Payment'] = 0;
        a['Need Payment']++;
      }
      return a
    }, {})

    const totalCost = campaign?.productCost + campaign?.shippingCost + campaign?.commission + campaign?.fixedPayments

    const campaignTags = [];
    if (campaign?.content?.format) campaignTags.push(campaign?.content?.format)
    if (campaign?.content?.baseType) campaignTags.push(campaign?.content?.baseType === 'fixed' ? 'one time' : campaign?.content?.baseType)
    if (campaign?.payments?.includeAffiliate) campaignTags.push('affiliate')
    if (campaign?.payments?.price) campaignTags.push('fixed payment')

    console.log('campaign', campaign)

    return (
      <ResourceItem
        id={campaign.id}
        onClick={onCampaignClick ? () => onCampaignClick(campaign.id) : () => {
          setInitialCampaign(campaign)
        }}
        verticalAlignment="center"
        media={
          <div style={{
            backgroundImage: `url(${campaign?.hero || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '150px',
            height: '100px'
          }} />
        }
        accessibilityLabel={`View details for ${campaign.campaignTitle}`}
      >
        <InlineGrid columns={showTasks ? "2fr 1fr" : '1'} blockAlign="center" align="space-between">
          <BlockStack inlineAlign="start" gap="2">
            <Text variant="headingMd" fontWeight="bold" as="span">
              {campaign.campaignTitle}
            </Text>
            <InlineStack gap="100">
              {
                campaignTags.map((tag, index) => {
                  return <Tag key={index}>{tag}</Tag>
                })
              }
            </InlineStack>
            <InlineStack gap="300" blockAlign="center">
              <InlineStack gap="100" inlineAlign="center">
                <Text variant="bodyMd" color="subdued">
                  Creators
                </Text>
                <Text variant="headingSm" color="subdued" fontWeight="semibold">{campaign?.creators}</Text>
              </InlineStack>
              <InlineStack gap="100" inlineAlign="center">
                <Text variant="bodyMd" color="subdued">
                  Revenue
                </Text>
                <Text variant="headingSm" color="subdued" fontWeight="semibold">{numberToUSD(campaign?.totalRevenue, store?.paymentSettings?.currencyCode, 0)}</Text>
              </InlineStack>
              <InlineStack gap="100" inlineAlign="center">
                <InlineStack gap="100">
                  <Text variant="bodyMd" color="subdued">
                    Cost
                  </Text>
                </InlineStack>
                <Text variant="headingSm" color="subdued" fontWeight="semibold">{numberToUSD(totalCost, store?.paymentSettings?.currencyCode, 0)}</Text>
                <Tooltip content={
                  <BlockStack gap="100">
                    <Text variant="bodySm" color="subdued">
                      Product Cost: {numberToUSD(campaign?.productCost, store?.paymentSettings?.currencyCode)}
                    </Text>
                    <Text variant="bodySm" color="subdued">
                      Shipping Cost: {numberToUSD(campaign?.shippingCost, store?.paymentSettings?.currencyCode)}
                    </Text>
                    <Text variant="bodySm" color="subdued">
                      Commission: {numberToUSD(campaign?.commission, store?.paymentSettings?.currencyCode)}
                    </Text>
                    <Text variant="bodySm" color="subdued">
                      Fixed Payments: {numberToUSD(campaign?.fixedPayments, store?.paymentSettings?.currencyCode)}
                    </Text>
                  </BlockStack>
                }>
                  <Icon source={CaretDownIcon} color="subdued" />
                </Tooltip>
              </InlineStack>
            </InlineStack>
          </BlockStack>
          {
            showTasks ? (
              <BlockStack blockAlign="center" inlineAlign="end" gap="100">
                {
                  Object.entries(campaignTasks).map(([task, count]) => {
                    return (
                      getTaskIcon(task, `${count} ${task}`)
                    )
                  })
                }
              </BlockStack>
            ) : null
          }
        </InlineGrid>
      </ResourceItem>
    )
  }, [])

  return (
    <div style={minWidth ? { minWidth: '800px' } : {}}>
      <BlockStack inlineAlign="stretch" gap="300">
        <BlockStack gap="500">
          <Card padding="0">
            <ResourceList
              resourceName={resourceName}
              items={campaignStats || []}
              renderItem={renderItem}
              emptyState={
                <EmptyState
                  heading={
                    <BlockStack inlineAlign="center">
                      <Image width="100%" source={'https://assets.codepen.io/6060109/create-campaign.png'} />
                      <Text variant="headingMd">No Campaigns Yet</Text>
                    </BlockStack>
                  }
                // action={{ content: 'Create Campaign', onAction: onCreateCampaign ? onCreateCampaign : () => setCampaignOpen({}) }}
                />
              }
            />
          </Card>
        </BlockStack>
      </BlockStack>
    </div>
  )
}
